module.exports = __webpack_public_path__ + "bca98be1aa4fa4dfc43c08f37065048c.jpg";